import { ColumnModel } from "../../modules/api/api.models"
import { LocalizationHelper } from "../../helpers"
import { Enums } from "../../models/common"

//#region Public Types

export const ATTACHMENT_SERVICE_NAME = 'attachmentService'
export const ATTACHMENT_SERVICE_PROVIDER_NAME = 'attachmentServiceProvider'

//#endregion

export class AttachmentService {

    // #region Ctor

    constructor() { }

    // #endregion

    // #region Public Methods

    public getAttachmentGridColumns(): ColumnModel[] {

        const physicalFileName: ColumnModel = new ColumnModel()
        const size: ColumnModel = new ColumnModel()
        const description: ColumnModel = new ColumnModel()
        const insertDate: ColumnModel = new ColumnModel()

        physicalFileName.idName = 'physicalFileName'
        physicalFileName.name = 'PhysicalFileName'
        physicalFileName.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)

        size.idName = 'size'
        size.name = 'Size'
        size.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Size)
        size.type = Enums.DataTypeClass.Decimal

        description.idName = 'description'
        description.name = 'Description'
        description.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Description)

        insertDate.idName = 'insertDate'
        insertDate.name = 'InsertDate'
        insertDate.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FillingDate)
        insertDate.type = Enums.DataTypeClass.Datetime

        return [physicalFileName, size, description, insertDate]
    }
 
    // #endregion
}

export class AttachmentServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new AttachmentService()
    }]

    //#endregion
} 
